export const serverIcon = [
  "24 24",
  `
    <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M4,2h16
	c1.104,0,2,0.896,2,2v4c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2V4C2,2.896,2.896,2,4,2z M4,14h16c1.104,0,2,0.896,2,2v4
	c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2v-4C2,14.896,2.896,14,4,14z M6,6h0.01 M6,18h0.01"/>
  `,
];
